<template>
	<v-dialog :value="value" max-width="640" @input="$emit('input', $event)">
		<v-card v-if="booking">
			<v-toolbar dark color="primary" flat>
				<v-toolbar-title>Richiesta demo</v-toolbar-title>
				<v-spacer></v-spacer>
				<v-chip :color="statusColor" dark small>{{ statusLabel }}</v-chip>
				<v-btn icon dark class="ml-2" @click="$emit('input', false)">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-toolbar>

			<v-list two-line>
				<v-list-item>
					<v-list-item-icon><v-icon>mdi-account</v-icon></v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>{{ fullName }}</v-list-item-title>
						<v-list-item-subtitle>Nome e cognome</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>

				<v-list-item>
					<v-list-item-icon><v-icon>mdi-email</v-icon></v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>
							<a :href="`mailto:${booking.email}`">{{ booking.email || '-' }}</a>
						</v-list-item-title>
						<v-list-item-subtitle>Email</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>

				<v-list-item>
					<v-list-item-icon><v-icon>mdi-phone</v-icon></v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>{{ booking.phone || '-' }}</v-list-item-title>
						<v-list-item-subtitle>Telefono</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>

				<v-list-item>
					<v-list-item-icon><v-icon>mdi-web</v-icon></v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>
							<a v-if="booking.website" :href="booking.website" target="_blank" rel="noopener">{{ booking.website }}</a>
							<span v-else>-</span>
						</v-list-item-title>
						<v-list-item-subtitle>Sito web</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>

				<v-list-item>
					<v-list-item-icon><v-icon>mdi-calendar-clock</v-icon></v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>{{ formattedDate }} &middot; {{ booking.slot }} ({{ booking.timeZone || 'Europe/Rome' }})</v-list-item-title>
						<v-list-item-subtitle>Data e orario richiesti</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>

				<v-list-item v-if="booking.message">
					<v-list-item-icon><v-icon>mdi-message-text</v-icon></v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title style="white-space: normal">{{ booking.message }}</v-list-item-title>
						<v-list-item-subtitle>Messaggio</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>

				<v-list-item v-if="booking.meetLink">
					<v-list-item-icon><v-icon>mdi-video</v-icon></v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>
							<a :href="booking.meetLink" target="_blank" rel="noopener">{{ booking.meetLink }}</a>
						</v-list-item-title>
						<v-list-item-subtitle>Link Google Meet</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>

				<v-list-item v-if="booking.htmlLink">
					<v-list-item-icon><v-icon>mdi-calendar-check</v-icon></v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>
							<a :href="booking.htmlLink" target="_blank" rel="noopener">Apri su Google Calendar</a>
						</v-list-item-title>
						<v-list-item-subtitle>Evento calendario</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>

				<v-list-item>
					<v-list-item-icon><v-icon>mdi-translate</v-icon></v-list-item-icon>
					<v-list-item-content>
						<v-list-item-title>{{ (booking.lang || '-').toUpperCase() }}</v-list-item-title>
						<v-list-item-subtitle>Lingua &middot; richiesta del {{ formatDateTime(booking.created_at) }}</v-list-item-subtitle>
					</v-list-item-content>
				</v-list-item>
			</v-list>

			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary" text @click="$emit('input', false)">Chiudi</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import moment from 'moment';

const STATUS = {
	scheduled: { label: 'Confermata', color: 'success' },
	pending: { label: 'In attesa', color: 'warning' },
	meet_failed: { label: 'Meet fallito', color: 'error' },
};

export default {
	name: 'DemoDetailDialog',
	props: {
		value: { type: Boolean, default: false },
		booking: { type: Object, default: null },
	},
	computed: {
		fullName() {
			if (!this.booking) return '-';
			return `${this.booking.firstName || ''} ${this.booking.lastName || ''}`.trim() || '-';
		},
		statusLabel() {
			return (STATUS[this.booking && this.booking.status] || { label: this.booking && this.booking.status }).label || '-';
		},
		statusColor() {
			return (STATUS[this.booking && this.booking.status] || { color: 'grey' }).color;
		},
		formattedDate() {
			return this.booking && this.booking.date ? moment(this.booking.date, 'YYYY-MM-DD').format('DD/MM/YYYY') : '-';
		},
	},
	methods: {
		formatDateTime(value) {
			return value ? moment(value).format('DD/MM/YYYY HH:mm') : '-';
		},
	},
};
</script>
